import Vue from "vue";

import ProductDetail from "./ProductDetail_Drawings.vue";

export function load() {
    const selector = "rewards-product-detail-drawings";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(ProductDetail, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
